export class objBodyMail {    
    RequestID: number = 0;
    RequestCode: string = null;
    Subject: string = null ;
    ToUser: string = null;
    CcUser: string = null;
    RequestTypeName: string = null;
    UserNameInternal: string = null;
    DeadlineFFMApproval: Date = null;
    DeadlineHSChecking: Date = null;
    DeadlineHSDone: Date = null;
    UrlAddr: string = null;
    OtherContent: string = null;

    public reset() {        
        this.RequestID = 0;
        this.RequestCode = null;
        this.Subject = null;
        this.ToUser= null;
        this.CcUser = null;
        this.RequestTypeName = null;
        this.UserNameInternal = null;
        this.DeadlineFFMApproval = null;
        this.DeadlineHSChecking = null;
        this.DeadlineHSDone = null;
        this.UrlAddr = null;
        this.OtherContent = null;
    }

    public set(p: any) {        
        this.RequestID = p.RequestID;
        this.RequestCode = p.RequestCode;
        this.Subject = p.Subject;
        this.ToUser = p.ToUser;
        this.CcUser = p.CcUser;
        this.RequestTypeName = p.RequestTypeName;
        this.UserNameInternal = p.UserNameInternal;
        this.DeadlineFFMApproval = p.DeadlineFFMApproval;
        this.DeadlineHSChecking = p.DeadlineHSChecking;
        this.DeadlineHSDone = p.DeadlineHSDone,
        this.UrlAddr = p.UrlAddr;
        this.OtherContent = p.OtherContent;
    }
}
